import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UploadResponse } from '../dtos/upload-response.dto';
import { SILENT_ERROR_HEADER } from '../../../common/constants/http-headers';

@Injectable({ providedIn: 'root' })
export class UploadsService {
  private http = inject(HttpClient);
  private readonly controller = 'Uploads';

  upload(file: File): Observable<UploadResponse> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<UploadResponse>(`${this.controller}`, form);
  }

  /**
   * Uploads with progress events; errors are not shown by the global error alert so the caller
   * can display them next to the file.
   */
  uploadWithProgress(file: File): Observable<HttpEvent<UploadResponse>> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<UploadResponse>(`${this.controller}`, form, {
      reportProgress: true,
      observe: 'events',
      headers: new HttpHeaders({ [SILENT_ERROR_HEADER]: '1' }),
    });
  }

  getById(id: number): Observable<UploadResponse> {
    return this.http.get<UploadResponse>(`${this.controller}/${id}`);
  }
}
